import { useSelector } from 'react-redux'
import { isInstitutionalMonitoring, getTenantType, getTenantInfo } from '../utils/tenantService'

/**
 * Custom hook for easy access to tenant type information
 * Follows the same pattern as other hooks in the codebase
 */
const useTenantType = () => {
    const profile = useSelector((state) => state.profile.profile)

    return {
        isInstitutionalMonitoring: isInstitutionalMonitoring(profile),
        tenantType: getTenantType(profile),
        tenant: getTenantInfo(profile),
        isInstitutional: isInstitutionalMonitoring(profile) // Alias for convenience
    }
}

export default useTenantType
